// extracted by mini-css-extract-plugin
module.exports = {"chartTitleRoot":"HNGfgkwm"};